'use strict';
import axios from 'axios';
import { ExecutionTypes } from '../interfaces/ExecutionTypes';

const getExecutions = async (githubUser: string, githubToken: string, repository_name: string) => {

    const options = {
        method: 'GET',
        url: `https://api.github.com/repos/${githubUser}/${repository_name}/actions/runs`,
        headers: {
            Accept: 'application/vnd.github+json',
            Authorization: `token ${githubToken}`,
            'X-GitHub-Api-Version': '2022-11-28',
        }
    };

    const runs: ExecutionTypes[] = []

    await axios.request(options)
        .then(function (response) {

            console.log(response.data.workflow_runs.length)

            if (response.data.workflow_runs.length > 0) {

                response.data.workflow_runs.forEach((element: ExecutionTypes) => {
                    if (runs.length < 5) {
                        runs.push(element)
                    }
                });
            }
        })

    const jobs: any = []

    for (let index = 0; index < runs.length; index++) {
        const el = runs[index];

        const options = {
            method: 'GET',
            url: `https://api.github.com/repos/${githubUser}/${repository_name}/actions/runs/${el.id}/jobs`,
            headers: {
                Accept: 'application/vnd.github+json',
                Authorization: `token ${githubToken}`,
                'X-GitHub-Api-Version': '2022-11-28',
            }
        }

        await axios.request(options)
            .then(async function (res) {
                jobs.push({ ...el, jobs: res.data.jobs })
            })
    }

    return jobs
};

const createPipeline = async (githubUser: string, githubToken: string, repository_name: string, pipeline: string) => {

    const options = {
        method: 'POST',
        url: `https://api.github.com/repos/${githubUser}/${repository_name}/actions/workflows/${pipeline}/dispatches`,
        headers: {
            Authorization: `token ${githubToken}`,
            Accept: 'application/vnd.github.v3+json',
            'X-GitHub-Api-Version': '2022-11-28'
        },
        data: '{"ref":"main"}'
    };

    await axios.request(options).then(function (response) {
        console.log(response.data);
    }).catch(function (error) {
        console.error(error);
    });
};

const cancelExecution = async (cancel_url: string, githubToken: string) => {
    const options = {
        method: 'POST',
        url: cancel_url,
        headers: {
            Accept: 'application/vnd.github+json',
            Authorization: `token ${githubToken}`,
            'X-GitHub-Api-Version': '2022-11-28'
        }
    };

    await axios.request(options)
};

const reRunExecution = async (rerun_url: string, githubToken: string) => {

    const options = {
        method: 'POST',
        url: rerun_url,
        headers: {
            Accept: 'application/vnd.github+json',
            Authorization: `token ${githubToken}`,
            'X-GitHub-Api-Version': '2022-11-28'
        }
    };

    await axios.request(options)
};

export {
    getExecutions,
    createPipeline,
    cancelExecution,
    reRunExecution,
};
